import React, { Fragment } from 'react';
import { Item, Label, Icon, Popup, Button } from 'semantic-ui-react';

import DownloadLabel from '../DownloadLabel';
import DocumentPreview from '../DocumentPreview';

const ATTACHMENTS_TO_SHOW = 2;

const List = ({
  attachments,
  showAttachments,
  toggleAttachments,
  onOpenAttachmentPrev,
  toggleImportLabel,
  onImportToggleClick,
  selectedAttachments,
  handleAttachmentsSelectionChange
}) => {
  const attachmentsToRender = showAttachments
    ? attachments
    : attachments.slice(0, ATTACHMENTS_TO_SHOW);
  return (
    <Fragment>
      {attachmentsToRender.map(attachment => {
        const { id, attachmentContentType, attachmentFileName, status } =
          attachment || '';
        return (
          <Item className="inline-item" key={id}>
            <DocumentPreview
              type="thumbnail"
              document={attachment}
              onClick={onOpenAttachmentPrev.bind(this, attachment)}
            />
            <Item.Content>
              <Popup
                trigger={
                  <a onClick={onOpenAttachmentPrev.bind(this, attachment)}>
                    #{id}
                  </a>
                }
                content={attachmentContentType}
                position="right center"
                size="tiny"
              />
              <br />
              {attachmentFileName && attachmentFileName.split('.')[0]}
              <Item.Meta>
                {!toggleImportLabel &&
                  onImportToggleClick && (
                    <Label
                      basic
                      size="mini"
                      name={'btnImport' + id}
                      color={status === 'accepted' ? 'red' : 'green'}
                      onClick={onImportToggleClick.bind(this, attachment)}
                      style={{ cursor: 'pointer' }}
                    >
                      {status === 'accepted' ? 'discard' : 'accept'}
                    </Label>
                  )}
                <DownloadLabel document={attachment} />
                {selectedAttachments && (
                  <Icon
                    size="large"
                    name={
                      selectedAttachments.includes(id)
                        ? 'check circle outline'
                        : 'circle outline'
                    }
                    color={selectedAttachments.includes(id) ? 'green' : 'grey'}
                    style={{ cursor: 'pointer' }}
                    onClick={handleAttachmentsSelectionChange.bind(this, id)}
                  />
                )}
              </Item.Meta>
            </Item.Content>
          </Item>
        );
      })}

      {attachments.length > ATTACHMENTS_TO_SHOW && (
        <Item className="inline-item">
          <Item.Image size="tiny">
            <Button onClick={toggleAttachments}>
              {showAttachments ? 'Less Attachments' : 'More Attachments'}{' '}
            </Button>
          </Item.Image>
        </Item>
      )}
    </Fragment>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/component/AttachmentsList/List.js